import { render, staticRenderFns } from "./SportsPage.vue?vue&type=template&id=3339620a&scoped=true&"
import script from "./SportsPage.vue?vue&type=script&lang=js&"
export * from "./SportsPage.vue?vue&type=script&lang=js&"
import style0 from "./SportsPage.vue?vue&type=style&index=0&id=3339620a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3339620a",
  null
  
)

export default component.exports